import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

const MechanicCard = ({
    technicianDetails
}) => {
    const { title, description, imageUrl, subTitle } = technicianDetails || {};

    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.techinicianTextContainer"}>
                <div className="media" styleName={"styles.mediaContainer"}>
                    <img
                        src={imageUrl}
                        alt={`${title} - ${subTitle}`}
                    />
                    <div className="media-body">
                        <h2 styleName={"styles.name"}>{title}</h2>
                        <h3 styleName={"styles.title"}>{subTitle}</h3>
                        <p styleName={"styles.description"}>{description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

MechanicCard.propTypes = {
    technicianDetails: PropTypes.object
};

export default MechanicCard;
